import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { HomePage } from './components/HomePage';
import { ContactPage } from './components/ContactPage';
import { AboutPage } from './components/AboutPage';
import { GalleryPage } from './components/GalleryPage';
import { Corporate } from './components/Corporate';
import { Florals } from './components/Florals';
import { Birthdays } from './components/Birthdays';
import { Weddings } from './components/Weddings';
import { Lobola } from './components/Lobola';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/gallery/Corporate" element={<Corporate />} />
        <Route path="/gallery/Florals" element={<Florals />} />
        <Route path="/gallery/Birthdays" element={<Birthdays />} />
        <Route path="/gallery/Weddings" element={<Weddings />} />
        <Route path="/gallery/Lobola" element={<Lobola />} />
      </Routes>
    </div>
  );
}
